<template>
    <div :class="stateClasses" class="field select">
        <label v-if="label" :for="name" class="field__label">
            {{ label }}
            <span v-if="required">*</span>
        </label>
        <v-select
            class="field__input field--custom-select select__wrapper | u-margin-bottom-flush"
            v-model="newValue"
            :options="options"
            :label="optionLabel"
            :placeholder="placeholder"
        ></v-select>
        <img v-if="icon" class="select__icon" src="../assets/feather-icons/chevron-down.svg" />

        <template v-if="error">
            <span class="field__message">
                <small>{{ error }}</small>
            </span>
        </template>
    </div>
</template>

<script>
export default {
    name: 'SingleSelect',
    props: {
        value: {
            type: [Number, String],
            default: null
        },
        label: {
            type: String,
            default: null,
            required: false
        },
        name: {
            type: String,
            default: '',
            required: true
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        options: {
            type: Array,
            default: () => [],
            required: false
        },
        optionLabel: {
            type: String,
            default: 'key',
            required: false
        },
        optionValue: {
            type: String,
            default: 'value',
            required: false
        },
        error: {
            type: String,
            default: null
        },
        icon: {
            type: Boolean,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            newValue: null
        };
    },
    computed: {
        /**
         * Generate the state classes.
         *
         * @return {object}
         */
        stateClasses() {
            return {
                'has-error': this.error
            };
        }
    },
    methods: {
        /**
         * Get the current option.
         *
         * @param {object} options, value
         *
         * @return {object}
         */
        getCurrentOption({ options, value }) {
            let currentValue = value;

            let currentOptions = options;

            if (!currentValue) {
                currentValue = this.value;
            }

            if (!currentOptions) {
                currentOptions = this.options;
            }

            if (!currentOptions || !this.optionValue) {
                return;
            }

            return currentOptions.find(option => option[this.optionValue] == currentValue);
        }
    },
    watch: {
        /**
         * Check if the options are changed, set the new value.
         *
         * @param {array} options
         */
        options(options) {
            this.newValue = this.getCurrentOption({ options });
        },

        /**
         * When v-model is changed:
         *   1. Set internal value.
         *   2. If it's invalid, validate again.
         *
         * @param {string} value
         */
        value(value) {
            this.newValue = this.getCurrentOption({ value });
        },

        /**
         * Update the v-model and validate again whenever
         * internal value is changed.
         *
         * @param {string} value
         */
        newValue(value) {
            if (value && value[this.optionValue]) {
                this.$emit('input', value[this.optionValue]);

                return;
            }

            this.$emit('input', value);
        }
    }
};
</script>
